let $elements = $('.js-date-range-picker');

scrollDir({
	dir: "up",
	thresholdPixels: 20, // the default is 64 pixels
});

$(window).on('scroll resize', scrollDirUpdate);

function scrollDirUpdate() {
	
	// обрабатываем ситацию, когда юзер очень медленно проскроллит к началу страницы
	if($(window).scrollTop() === 0) {
		addAttrUp();
	}
	
	// если юзер проскролли до конца, то показываем шапку и кнопку меню 
	if ((window.innerHeight + Math.round(window.scrollY)) >= document.body.offsetHeight) {
		addAttrUp();
	}
	
	// если была горизонтальная прокрутка
	let ua = window.navigator.userAgent;
	let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
	let webkit = !!ua.match(/WebKit/i);
	let iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
	
	if( (window.scrollX > 50) && (typeof window.detectGorizontalScroll === 'undefined') && (!iOSSafari) ) {
		Rollbar.warning("Была зафиксирована горизонтальная прокрутка");
		window.detectGorizontalScroll = true;
	}
	
}

function addAttrUp() {
	$('html').attr('data-scrolldir', 'up');
}